import { Navigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import type { Role } from '../types/api'

const HOME_BY_ROLE: Record<Role, string> = {
  SUPER_ADMIN: '/superadmin',
  ADMIN_TENANT: '/admin',
  GESTOR_RH: '/rh',
  OPERADOR: '/rh/espelho',
  FUNCIONARIO: '/funcionario',
}

export function RoleRedirect() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  return <Navigate to={HOME_BY_ROLE[user.role]} replace />
}
